




























import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { AttentionRequired, DocumentContent, DocumentTypePrimitive } from "@infoland/iprova-api";
import storeHelper from "@/store/store-helper";
import { DocumentCheckOutcome, DocumentVersionState, SnackBarTimeout } from "@/enums";
import { DocumentTypeParagraphsResult } from "@/types/document/documentTypeParagraph";
import Shared from "@/shared";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import CheckDocument from "@/components/modules/document/CheckDocument.vue";
export default Vue.extend({
    name: "CheckDocumentAction",
    components: { DocumentToolbarAction, ZenyaDialog, CheckDocument },
    props: {
        documentVersionInfo: Object as () => DocumentVersionInfo,
        enable: Boolean
    },
    data: function () {
        return {
            showCheckDocumentDialog: false,
            hideCheckDocumentOkButton: false
        };
    },
    watch: {
        showCheckDocumentDialog: function () {
            storeHelper.siteStore.setIsDialogDisplayed(this.showCheckDocumentDialog);
        }
    },
    computed: {
        documentCanBeChecked(): boolean {
            return (
                storeHelper.documentStore.documentInfo &&
                storeHelper.documentStore.documentInfo.can_check_document &&
                storeHelper.documentStore.documentInfo.attention_required_flags &&
                (storeHelper.documentStore.documentInfo.attention_required_flags.includes(AttentionRequired.check_date_approaches) ||
                    storeHelper.documentStore.documentInfo.attention_required_flags.includes(AttentionRequired.check_date_exceeded))
            );
        },
        checkDocumentButtonText(): string {
            if (this.$vuetify.breakpoint.smAndDown) {
                return "document.checkButtonSmallDevice";
            } else {
                return "document.checkButton";
            }
        }
    },
    methods: {
        toggleCheckDocumentDialogOkButton(newValue: boolean): void {
            this.hideCheckDocumentOkButton = newValue;
        },
        async closeCheckDocumentMessageCallback(message): Promise<void> {
            if (message.data.checked == true) {
                await this.closeCheckDocumentDialog(DocumentCheckOutcome.archived);
            }
        },
        async closeCheckDocumentDialog(documentCheckOutcome: DocumentCheckOutcome): Promise<void> {
            if (documentCheckOutcome == DocumentCheckOutcome.delegated) {
                await storeHelper.siteStore.setSnackBarMessage(this.$t("checkDocument.documentDelegated").toString(), false, SnackBarTimeout.long);
            } else {
                await storeHelper.siteStore.setSnackBarMessage(this.$t("checkDocument.documentChecked").toString(), false, SnackBarTimeout.long);
            }

            if (documentCheckOutcome == DocumentCheckOutcome.archived) {
                this.$router.push({ name: "Tasks" });
            } else {
                this.showCheckDocumentDialog = false;
                await storeHelper.documentStore.loadDocumentAsync(this.documentVersionInfo.document_id);
                if (!this.documentCanBeChecked) {
                    this.$router.push({ name: "Tasks" });
                }
            }
        },
        async openCheckDocumentDialog(): Promise<void> {
            let documentTypeChanged = false;
            if (this.documentVersionInfo.type == DocumentTypePrimitive.structured_document) {
                let docContent: DocumentContent = (await storeHelper.documentStore.getDocumentContentByStateAsync(
                    this.documentVersionInfo.document_id,
                    DocumentVersionState.Published
                )) as DocumentContent;
                let documentTypeParagraphsResult: DocumentTypeParagraphsResult = await storeHelper.documentStore.getDocumentTypeParagraphsAsync(
                    this.documentVersionInfo.document_type.id
                );
                let paragraphs = docContent.paragraphs;
                documentTypeChanged = !(
                    documentTypeParagraphsResult.documentTypeExists &&
                    !(paragraphs.length > documentTypeParagraphsResult.documentTypeParagraphs.length)
                );
                if (!documentTypeChanged) {
                    //compare every paragraph
                    for (let i = 0; i < paragraphs.length; i++) {
                        if (paragraphs[i].paragraph_id != documentTypeParagraphsResult.documentTypeParagraphs[i].paragraph_id) {
                            documentTypeChanged = true;
                        }
                    }
                }
                if (documentTypeChanged) {
                    window.addEventListener("message", this.closeCheckDocumentMessageCallback, false);
                    window.open(
                        Shared.iProvaUrl +
                            `/iDocument/Management/Documents/Check/Wizard_CheckDocument.aspx?DocumentID=${this.documentVersionInfo.document_id}`
                    );
                }
            }
            this.showCheckDocumentDialog = !documentTypeChanged;
        }
    }
});
